 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		26: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"npm.quill","5":"npm.react-dom","6":"npm.react-quill","9":"npm.babel","10":"npm.emoji-picker-react","11":"npm.react-dd-menu","12":"npm.react-papaparse","13":"npm.react-player","14":"npm.readable-stream","18":"npm.canvg","19":"npm.create-react-class","20":"npm.d3-scale","21":"npm.dompurify","22":"npm.react-querybuilder","23":"npm.react-smooth","24":"npm.react-sortable-hoc","25":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"0af48241774abd6ecf67","2":"c9e7a6492386f3277f85","3":"9b838e1a4443f25be7aa","4":"94241da72c1fa6de79ff","5":"20e1f75c922e3d3f3034","6":"1acd51c2bb65d54eae71","7":"b1a7f85980cb9e32fb9d","8":"458b825d35cd8665c00a","9":"f40e9c0a0b4d005967f9","10":"21a38bb82de79c442dfe","11":"47789c9e20963bf6c053","12":"c20eb5721b6e0b9a02fe","13":"78e80c658ae144c5937f","14":"595c4fa04c9c98f5417f","15":"501f2b68e8bb779cfc7a","18":"60801fedcbcbf194cedb","19":"df2336024ddc5dc39567","20":"53276394962f6600858a","21":"f98419d4cc8ed9b581bb","22":"aea9a033bfa0e2e2ff81","23":"60be86c4cd67c3937270","24":"754bb30c4f2a452a4882","25":"9df6564a3d733b74319f","27":"373bbf77d8ccabf69ea4","28":"797d28f485d845c25466","29":"ec97c4edcb2de03b3628","30":"f7ee7982705fbb0d6cc3","31":"4cfa9af511e2455cc29d","32":"c0205a57709b106911a3","33":"3c9fcb58b56662ad685f","34":"a5793adf8ffcfd30632a","35":"879852445ad9c4bb0e66","36":"e9d9d7a30d232ce25174","37":"6f7c37866a826d8697a1","38":"ea8a65353f1688fe8860","39":"6b09381705591cf23776","40":"7ca4f4c44da4f1da9f98","41":"8fcb01c7df1ebf89d0d1","42":"0f0e5fa61004e590f146","43":"05e761a9df716bc2c9d5","44":"b2aa57bc6f259c2a79bf","45":"11c15163f8a918ee051a","46":"7ce4f6bfcfb21ba531a9","47":"a2ad343140866883ce3a","48":"7d4cd1a13491bb04b858","49":"6d332eafe585977f91ca","50":"2159488cb1bbb04a4e09","51":"e08298b4fbd6acc9e7b0","52":"b7ff3a78701199f12e9f","53":"2d395daf3a1b1da741e8","54":"f0666e646702af733cda","55":"9e701b801eee452be8a7","56":"4d2c8291c39dc0bb327e","57":"ca6028806a85e9c9f304","58":"46b61529293701be9420","59":"dfc52cdd71282d6c2b02","60":"8350e8349df9dc99a05a","61":"75cf1909eb4b0c01fbcd","62":"1c3f46d1d2cd78d730bf","63":"1ecf50fdcad3c5dcb49d","64":"e7aefddd50113f2c535c","65":"844e5bb410e4103563d4","66":"6697817c6663c64cea94","67":"4dfce4653f0ab67fcad9","68":"9a65e10f9faf18454fba","69":"59b716a34f8fae0a385e","70":"88e9a5ad3c4662661ad5","71":"585cf6d1615b80931b90","72":"1ae1aeb6f0db14e97709","73":"2dea57a8b7ba1b7fec52","74":"896ecd76e52b54642ad0","75":"d81b4c815d162c16d68d","76":"0d63ba2b92d132cae49b","77":"0ba4f0bc063814dddcfc","78":"bc2292ebcd73f8b2cb6c","79":"b9dac0d97e9a3777a60c","80":"1edf1225dbbbf05622d5","81":"33e4cbae4d658ddd7167","82":"80a07d81cce94450c53b","83":"846dc0aee7a40a6dece6","84":"7d06248c15a1aa35712c"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/8f3151e/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
